import type { ComponentSchema } from "../../../../../schema-types"

export const schema: ComponentSchema = {
  type: 'order-success',
  label: 'Order Success Section',
  description: 'The order confirmation page section.',
  supportedPages: ['order-success'],
  variants: [{ id: 'v1', label: 'V1' }],
  commonFields: [
    { key: 'title', label: 'Success Title', type: 'string', default: 'Order Confirmed' },
    { key: 'message', label: 'Success Message', type: 'text', default: 'Your order has been placed successfully. We have sent a confirmation email with your order details.' },
    { key: 'loadingText', label: 'Loading Text', type: 'string', default: 'Loading order details...' },
    { key: 'errorTitle', label: 'Error Title', type: 'string', default: 'Order Not Found' },
    { key: 'errorMessage', label: 'Error Message', type: 'string', default: 'We could not find the order you are looking for.' },
    { key: 'viewOrderText', label: 'View Order Button Text', type: 'string', default: 'View Order Status' },
    { key: 'viewOrderLink', label: 'View Order Link', type: 'string', default: '/account/orders' },
    { key: 'continueShoppingText', label: 'Continue Shopping Text', type: 'string', default: 'Continue Shopping' },
    { key: 'continueShoppingLink', label: 'Continue Shopping Link', type: 'string', default: '/shop' },
  ],
}
